import { colours } from "@affinity/constants/StyleConstants";
import { rem } from "@affinity/constants/StyleHelpers";
import styled from "styled-components";

export const Divider = styled.hr`
    width: 100%;
    border: none;
    border-top: ${rem(3)} solid ${colours.lightGreen20};
`;
